import React from 'react'

import AssetsLoader from './_load/AssetsLoader'
import AssetsTable from './table/AssetsTable'
import ControlBar from './ControlBar'
import MultiRowsActions from './table/MultiRowsActions'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'

const PageContent = () => {
  return (
    <>
      <ControlBar />

      <MultiSelectHandler>
        <AssetsLoader uncontrolledChildren={<MultiRowsActions />}>
          <AssetsTable />
        </AssetsLoader>
      </MultiSelectHandler>
    </>
  )
}

export default PageContent
